import firebase, {User} from 'firebase/app';
import 'firebase/analytics';
import 'firebase/database';
import 'firebase/auth';
import {LoggedInUser} from '@/application/data/LoggedInUser';
import Debug from 'debug';
import {removeSentryUser, setSentryUser} from '@/sentry';
import Database = firebase.database.Database;
import { Store } from 'vuex';

const log = Debug('firebase.ts')

export function initFirebase(store: any): void {
  const firebaseConfig = {
    apiKey: 'AIzaSyCeXDwLOJwIbMipnMSyPOl2i-_3h2TLr60',
    authDomain: 'lupfen-dad4f.firebaseapp.com',
    databaseURL: 'https://lupfen-dad4f.firebaseio.com',
    projectId: 'lupfen-dad4f',
    storageBucket: 'lupfen-dad4f.appspot.com',
    messagingSenderId: '776489245371',
    appId: '1:776489245371:web:8f5c8af2b9b80be6a6a79e',
    measurementId: 'G-18N76J2XXD'
  };

  firebase.initializeApp(firebaseConfig);
  firebase.analytics();
  log("Firebase initialized")

  firebase.auth().onAuthStateChanged((user: User | null): void => {
    log('Received new FirebaseAuthState')
    let loggedInUser = user ? new LoggedInUser(user.uid, user.email!, user.displayName!) : null;

    if (loggedInUser)
      setSentryUser(loggedInUser.uid, loggedInUser.displayName)
    else
      removeSentryUser()

    store.commit('updateLoggedInUser', loggedInUser)
  });
}

export function getDatabase(): Database {
  return firebase.database();
}
